import { SolViewId, SolViewOptions, SolViewSeverityOptions } from '@sol/components';

export class AsmViewId {
  public static readonly score = SolViewId.of<SolViewSeverityOptions>('score', {
    maxValue: 1,
    format: 'grade',
    decimalCount: 0,
  });
  public static readonly priority = SolViewId.of<SolViewOptions>('priority');
  public static readonly country = SolViewId.of<SolViewOptions>('asm.country');
}
